var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import Modal from "../Semantic/Modal";
import styles from "../../styles/Card.module.scss";
export var CardModal = function (_a) {
    var card = _a.card, _b = _a.size, size = _b === void 0 ? 300 : _b, trigger = _a.trigger;
    return (_jsx(Modal, __assign({ basic: true, size: "mini", trigger: trigger }, { children: _jsx("div", __assign({ className: styles.modal }, { children: _jsx(Card, { card: card, size: size }, void 0) }), void 0) }), void 0));
};
export var SimpleCard = function (_a) {
    var uid = _a.uid, size = _a.size;
    var imgUrl = "https://c1.scryfall.com/file/scryfall-cards/normal/front/".concat(uid[0], "/").concat(uid[1], "/").concat(uid, ".jpg");
    return _jsx(ImageCard, { url: imgUrl, size: size }, void 0);
};
export var Card = function (_a) {
    var _b;
    var card = _a.card, size = _a.size;
    var imgUrl = (card.card_faces && card.card_faces[0].image_uris)
        ? card.card_faces[0].image_uris.normal
        : (_b = card.image_uris) === null || _b === void 0 ? void 0 : _b.normal;
    if (!imgUrl)
        return null; // interesting case for the scryfall id
    return _jsx(ImageCard, { url: imgUrl, size: size }, void 0);
};
var ImageCard = function (_a) {
    var url = _a.url, _b = _a.size, size = _b === void 0 ? 220 : _b;
    return _jsx("img", { width: size, className: styles.card, src: url }, void 0);
};
